/** Shared close control for article photo / video / PDF viewers. */
export const articleMediaCloseButtonSx = {
  position: 'absolute',
  top: 8,
  right: 8,
  zIndex: 2,
  backgroundColor: 'rgba(255,255,255,0.85)',
};

export const articleMediaDialogContentSx = {
  position: 'relative',
  p: { xs: 1, sm: 2 },
};
